/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { VISA_HAUL_LABEL, VISAHAUL_CONSTANT, FLEX_STUDY_TAG,
  STORIES_FEATUREID,
} from '../../constants';
import * as studyActions from '../../actions/studyActions';
import CommonStudySelector from "../common/CommonStudySelector";
import {
  clearSampleWeighted,
  deleteCrosstabGrid,
} from '../../actions/crosstabActions';
import enlargeIcon from '../../images/enlarge-icon_48-67-93.png';
import enlargeHoverIcon from '../../images/enlarge-icon_brown.png';
import targetIcon from '../../images/target-icon_blue.png';
import targetHoverIcon from '../../images/target-icon_red.png';
import targetDisabledIcon from '../../images/target-icon_grey.png';
import runIcon from '../../images/run_report_icon_normal.png';
import runHoverIcon from '../../images/run_report_icon_hover.png';
import runDisabledIcon from '../../images/run_report_icon_disabled.png';
import SmartSearch from '../common/SmartSearch/SmartSearch';
import { filterStudies } from '../../util/CommonUtils';

class StoriesSmartSearchEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // isViewScreenSelected: false,
      studies: this.props.studies ? filterStudies(this.props.studies, FLEX_STUDY_TAG) : [],
      defaultStudy: {},
      showWeightType: true,
      isTagInputExpanded: true,
      targetBtnDisabled: true,
      // runBtnDisabled: true,
    };
    this.smartSearchBox = React.createRef();
    this.crosstabViewer = React.createRef();
  }

  // UNSAFE_componentWillMount() {
  //   if (this.props.crosstabTableList && this.props.crosstabTableList.length) {
  //     this.setState({ isViewScreenSelected: true });
  //   }
  // }

  componentDidMount() {
    this.onMount();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // if (this.props.crosstabTableList !== nextProps.crosstabTableList) {
    //   this.setState({
    //     isViewScreenSelected:
    //       nextProps.crosstabTableList && nextProps.crosstabTableList.length > 0,
    //   });
    // }
    if (nextProps.studies && nextProps.studies !== this.props.studies) {
      this.setState(() => ({ studies: filterStudies(nextProps.studies, FLEX_STUDY_TAG) }));
    }
    if (nextProps.visahaulStudy
      && nextProps.visahaulStudy !== this.props.visahaulStudy) {
      this.setState(() => ({
        defaultStudy: nextProps.visahaulStudy,
      }));
    }
    if (nextProps.kpiInfo !== this.props.kpiInfo) {
      if (nextProps.kpiInfo && nextProps.kpiInfo.intab) {
        this.setState({ targetBtnDisabled: false });
      } else {
        this.setState({ targetBtnDisabled: true });
      }
    }
  }

  onMount = () => {
    if (this.props.visahaulStudy) {
      this.setState(() => ({
        defaultStudy: this.props.visahaulStudy,
      }));
    }
  }

  getCrosstabTitle = () =>
    this.crosstabViewer && this.crosstabViewer.current
      ? this.crosstabViewer.current.getCrosstabTitle()
      : 'untitled';

  setSelectedStudy = (selectedStudy, updatedWeightType) => {
    // this.setState(() => ({ actualWeightType: selectedStudy.wt }));
    this.props.handleStudyChange(selectedStudy, updatedWeightType);
  }

  handleCrosstabEdit = (idKey, dataSmartSearch) => {
    this.smartSearchBox
      .current
      .editCrosstabGrid(idKey, dataSmartSearch);
  };

  resetSmarchSearch = () => this.smartSearchBox.current.resetAll();

  // toggleCrosstabView = isViewScreenSelected =>
  //   this.setState({ isViewScreenSelected });

  handleChangeWeightType = weightType => {
    const updatedStudyItem = {
      ...this.state.defaultStudy,
      wt: weightType,
    };
    this.props.studyActions.updateModuleStudy('visahaul', updatedStudyItem);
  }

  handleToggleSearchEditor = () => {
    this.smartSearchBox.current.toggleSearchEditor();
  }

  /**
   * To update target grid of Visa Haul /Stories
   */
  handleVisaHaulMove = targetGrid => {
    const {
      expressionFormed,
      objectsAdded,
      selectedCategoryID,
      tags,
    } = this.smartSearchBox.current.state;
    this.smartSearchBox.current.handleSelectedIndexState();
    const objSmartSearchArray = [
      { expressionFormed, objectsAdded, selectedCategoryID, tags },
    ];
    if (this.props.visahaulStudy && expressionFormed.length > 0) {
      const selectedNames = [
        objectsAdded.reduce(
          (acc, { shortText }) => `${acc} ${shortText}`,
          '',
        ),
      ];
      const sampleWeightedParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: this.props.visahaulStudy.pn,
        weightType: this.props.storiesWeightTypes.wt,
        divisor: this.props.storiesWeightTypes.dv,
        gridData:
          this.props.gridData[targetGrid] &&
            (targetGrid !== 'TargetDataGrid' && targetGrid !== 'BaseDataGrid')
            ? this.props.gridData[targetGrid]
            : [],
        expressionList: [expressionFormed.join(' ')],
        originalNames: selectedNames,
        selectedNames,
        targetGrid,
        objSmartSearchArray,
      };
      this.props.getSampleWeighted(sampleWeightedParams);
      this.smartSearchBox.current.resetAll();
      this.setState({ targetBtnDisabled: true });
    }
  };

  resetAll = () => {
    this.setState({ targetBtnDisabled: true });
  }

  render() {
    return (
      <div>
        <div>
          <div className="smart-search-editor">
            <div className="appBreadcrumb">
              <div
                className="crosstab-study-selector"
              >
                <CommonStudySelector
                  studies={this.state.studies}
                  featureID={STORIES_FEATUREID}
                  defaultStudy={this.state.defaultStudy}
                  dataOnScreen={this.checkSCTabHasData}
                  alertMsg="This selection will impact all of the Crosstab modules"
                  setMethod={this.setSelectedStudy}
                  resetMethod={click => {
                    this.resetSelectedSCStudy = click;
                    return this.resetSelectedSCStudy;
                  }}
                  showWeightType={this.state.showWeightType}
                  handleChangeWeightType={this.handleChangeWeightType}
                  hideWeightType={this.props.hideWeightType}
                  style={{
                    fontWeight: 'bold',
                    color: '#4e0e28',
                  }}
                  menuName={VISA_HAUL_LABEL}
                  selectedWeightType={this.props.storiesWeightTypes}
                />
              </div>
              <div className="essential-breadcrumb">
                <span className="parent">Essentials / </span>{VISA_HAUL_LABEL}
              </div>
            </div>
            <SmartSearch
              selectedModule={VISAHAUL_CONSTANT}
              moduleStudy={this.props.visahaulStudy}
              getSampleWeighted={this.props.getSampleWeighted}
              fetchKPI={this.props.fetchKPI}
              gridData={this.props.gridData}
              runVisaHaul={this.props.runVisaHaul}
              dataScreen={this.props.dataScreen}
              ref={this.smartSearchBox}
              viewerGridType={
                this.props.crosstabTableList &&
                this.props.crosstabTableList.length > 0 &&
                this.props.crosstabTableList[0].viewerGridType
              }
              trackerFn={this.props.trackerFn}
              isTagInputExpanded={this.state.isTagInputExpanded}
              resetAll={this.resetAll}
            />
            <div className="move-to-wrapper visa-haul-wrapper">
              <div className="button-group">
                <button
                  type="button"
                  className="button square-button"
                  onMouseOver={this.mouseOver}
                  onMouseOut={this.mouseOut}
                  onClick={() =>
                    this.setState(prevState => ({
                      isTagInputExpanded: !prevState.isTagInputExpanded,
                    }))
                  }
                  onFocus={() => {}}
                  onBlur={() => {}}
                >
                  <div className="square">
                    {!this.state.isTagInputExpanded ? (
                      <img
                        src={enlargeIcon}
                        data-src={enlargeIcon}
                        data-hoversrc={enlargeHoverIcon}
                        alt="Expand Smart Search"
                        title="Expand Smart Search"
                      />
                    ) : (
                        <img
                          src={enlargeHoverIcon}
                          data-src={enlargeHoverIcon}
                          data-hoversrc={enlargeHoverIcon}
                          alt="Expand Smart Search"
                          title="Expand Smart Search"
                        />
                    )}
                    <span>EXPAND</span>
                  </div>
                </button>
                {this.state.targetBtnDisabled ? (
                    <button type="button" className="button square-button" disabled>
                      <div className="square">
                        <img
                          src={targetDisabledIcon}
                          data-src={targetDisabledIcon}
                          data-hoversrc={targetDisabledIcon}
                          alt="Move to target"
                          title="Move to target"
                        />
                        <span>TARGET</span>
                      </div>
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="button square-button"
                      onMouseOver={this.mouseOver}
                      onMouseOut={this.mouseOut}
                      onClick={() => this.handleVisaHaulMove('VisaTargetDataGrid')}
                      onFocus={() => {}}
                      onBlur={() => {}}
                    >
                      <div className="square">
                        <img
                          src={targetIcon}
                          data-src={targetIcon}
                          data-hoversrc={targetHoverIcon}
                          alt="Move to target"
                          title="Move to target"
                        />
                        <span>TARGET</span>
                      </div>
                    </button>
                  )}
                {(!this.props.gridData.TargetDataGridData ||
                this.props.gridData.TargetDataGridData.length <= 0) && (
                    <button type="button" className="button square-button" disabled>
                      <div className="square">
                        <img
                          src={runDisabledIcon}
                          data-src={runDisabledIcon}
                          data-hoversrc={runDisabledIcon}
                          alt="Run Analysis"
                          title="Run Analysis"
                        />
                      </div>
                    </button>
                  )}
                {this.props.gridData.TargetDataGridData &&
                  this.props.gridData.TargetDataGridData.length > 0 && (
                    <button
                      type="button"
                      className="button square-button"
                      onMouseOver={this.mouseOver}
                      onMouseOut={this.mouseOut}
                      onClick={() => this.props.runVisaHaul()}
                      onFocus={() => {}}
                      onBlur={() => {}}
                    >
                      <div className="square">
                        <img
                          src={runIcon}
                          data-src={runIcon}
                          data-hoversrc={runHoverIcon}
                          alt="Run Analysis"
                          title="Run Analysis"
                        />
                      </div>
                    </button>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

StoriesSmartSearchEditor.propTypes = {
  crosstabTableList: PropTypes.arrayOf(PropTypes.object),
  visahaulStudy: PropTypes.shape({
    pn: PropTypes.number,
  }),
  getSampleWeighted: PropTypes.func,
  fetchKPI: PropTypes.func,
  gridData: PropTypes.shape({
    TargetDataGridData: PropTypes.arrayOf(PropTypes.object),
  }),
  runVisaHaul: PropTypes.func,
  dataScreen: PropTypes.string,
  study: PropTypes.shape({
    crosstabStudy: PropTypes.shape({
    }),
  }),
  handleStudyChange: PropTypes.func,
  studyActions: PropTypes.shape({
    updateModuleStudy: PropTypes.func,
  }),
  trackerFn: PropTypes.func,
  studies: PropTypes.arrayOf(PropTypes.object),
  storiesWeightTypes: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
  }),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      token: PropTypes.string,
      uid: PropTypes.number,
    })
  }),
  activeAccountId: PropTypes.number,
  kpiInfo: PropTypes.shape({
    intab: PropTypes.number,
  }),
  hideWeightType: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    crosstabTableList: state.crosstab.crosstabTableList,
    study: state.study,
    studies: state.study.studies,
    visahaulStudy: state.study.visahaulStudy,
    kpiInfo: state.crosstab.kpiInfo,
    storiesWeightTypes: state.study.storiesWeightTypes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearSampleWeighted: bindActionCreators(clearSampleWeighted, dispatch),
    deleteCrosstabGrid: bindActionCreators(deleteCrosstabGrid, dispatch),
    studyActions: bindActionCreators(studyActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(StoriesSmartSearchEditor);
